"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[164],{

/***/ 164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileMOT": function() { return /* binding */ GarageProfileMOT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7245);
/* harmony import */ var _App_components_common_ServiceProviderHint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6491);




var GarageProfileMOTComponent = function(param) {
    var garage = param.garage;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: ((ref = garage.checkpoint) === null || ref === void 0 ? void 0 : ref.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "col-span-full bg-gray-100 rounded-lg p-5 mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg font-serif mb-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                        id: "checkpoint_title"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "inline-block md:inline-flex gap-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_App_components_common_ServiceProviderHint__WEBPACK_IMPORTED_MODULE_2__/* .ServiceProviderHint */ .h, {
                            providerId: garage.checkpoint.id.toString(),
                            hintType: "mot",
                            classes: "inline-block mx-auto my-0 md:mx-0 md:flex align-middle mr-2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "md:basis-[70%]",
                            children: [
                                "In dieser Werkstatt kannst du auch deine Hauptuntersuchung durchf\xfchren lassen. Ein Pr\xfcfer von ",
                                (ref1 = garage.checkpoint) === null || ref1 === void 0 ? void 0 : ref1.name,
                                " kommt daf\xfcr bei der Werkstatt vorbei."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
// Connect the component to the Redux store
var GarageProfileMOT = GarageProfileMOTComponent;


/***/ }),

/***/ 6491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ServiceProviderHint; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/assets/images/dekra.png
/* harmony default export */ var dekra = ({"src":"/_next/static/media/dekra.45c9449a.png","height":20,"width":70,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR4nA2KoQ2AQBTF+iTjoFkBlsCwC8OxAigSPLmc+1fVNmk414OkAxfUIn9IyVDcDttuP/brMANNV5n0bwAaQRAtjkxVfwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/tuev-sued.png
/* harmony default export */ var tuev_sued = ({"src":"/_next/static/media/tuev-sued.604d723e.png","height":129,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA90lEQVR42h1OQS8DYRR8f4mz0NRBemlvIriVSJy04eBe4uTiL7Rx0uxuEVZCN3xFSjcIFz3QICUcNnyV3e3r9H07ySQvM3kzQwaTRXeMpu2IJvaQcMaJ0gXRDNKF43HKWsH6zhUa/jur1hsXtxUoZwepFfForhYvb3nofn5zHPUw4BD6P+SlzTpofj+WiCq85iur81McHB6hXNnFbbMB96LNlLEgA6o4u37h7kcHSl0mbD8/yVOHKSV7aLamFzc8BL+9/v3dDR4fWvjTYX+hVIfUa5padUcpZ33lSx7Kto+K4yMvptESzyCzdjIiST+UdbShuRONiIZ71J2EsZqpdwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/tuev-rheinland.png
/* harmony default export */ var tuev_rheinland = ({"src":"/_next/static/media/tuev-rheinland.34a32c1f.png","height":157,"width":183,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAoklEQVR42mP4//8/AxAzMGSvZQTTWSshdPYaCA3lMEFpLSCeCFG4FklB4lyo7jXxQBwLVOQO5qctY2FgSF/ODObkrHcDWtMFxD1ARbMYdv+HaGJouQJhpC4JYchYUcGQtToYqNiRIWKCLAMDAxPEChljZSDHAYiNgVgTiFWA2JxBUs8AoqBgMxdD5kpphpy1EgxpS2QYUhbKMqQulmJIXSwCAMEhXJ/HEEJpAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/assets/images/kues.png
/* harmony default export */ var kues = ({"src":"/_next/static/media/kues.d5d0810e.png","height":129,"width":193,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAiElEQVR42nXKMQ4BURRG4V8nIlG5b965JCqFhCgUIiERGY1So7Ybe7AAlUprDXZARkOwAB2j08yXnO4oU2xnYvtU3LwVhx8lZf27ivW5REf4SAnTtM7CjTQGlgRf6S4GynWNV8vY14LvovkB40jgpJsYC69Ug/fzodcwZhgTzH/NdRE8FJsq8AVVnxry0VGY6AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/assets/images/gtue.png
/* harmony default export */ var gtue = ({"src":"/_next/static/media/gtue.efa53f7b.png","height":128,"width":292,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAiklEQVR4nGM8evpMEPvZC4mMX74yMLCw/GD4/5+f5fL1G8zzNvH/55NgZTw7Yeom9oJsFwYG0WMMDD+YGRg4rRgYxA79F+fRZvj97z/j2f4pWzgKc0z/MwidYGR4t/o/g2A+E8P7rH8M7NsZGJj/I6z49v3HX2nJ88wvXhl8tzFfxnHybADj128SAPqfOCowDTauAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/tuev-nord.png
/* harmony default export */ var tuev_nord = ({"src":"/_next/static/media/tuev-nord.3bd399d4.png","height":133,"width":276,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42mNg8lvIDMLMfguZgDQLEMtDsToQSzPgA0AFqiAiFIh9gdgFiD2BOACIY5n8FtkAaQkGILEailuAeBsQ7wLii0DcxOS3kA0AlEQfEL/9u3sAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./components/common/ServiceProviderHint.tsx











var ServiceProviderHint = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ServiceProviderHint, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ServiceProviderHint);
    function ServiceProviderHint() {
        (0,_class_call_check/* default */.Z)(this, ServiceProviderHint);
        return _super.apply(this, arguments);
    }
    var _proto = ServiceProviderHint.prototype;
    _proto.render = function render() {
        var _props = this.props, providerId = _props.providerId, hintType = _props.hintType, classes = _props.classes;
        var providersizes = {
            "mot": {
                "1": {
                    "width": 90,
                    "height": 25,
                    "image": dekra,
                    "alt": "DEKRA"
                },
                "2": {
                    "width": 60,
                    "height": 60,
                    "image": tuev_sued,
                    "alt": "TUEV Sued"
                },
                "3": {
                    "width": 128,
                    "height": 110,
                    "image": tuev_rheinland,
                    "alt": "TUEV Rheinland"
                },
                "4": {
                    "width": 70,
                    "height": 48,
                    "image": kues,
                    "alt": "KUES"
                },
                "5": {
                    "width": 100,
                    "height": 50,
                    "image": gtue,
                    "alt": "GTUE"
                },
                "6": {
                    "width": 70,
                    "height": 32,
                    "image": tuev_nord,
                    "alt": "TUEV Nord"
                }
            },
            "seperator": {
                "1": {
                    "width": 35,
                    "height": 10,
                    "image": dekra,
                    "alt": "DEKRA"
                },
                "2": {
                    "width": 30,
                    "height": 30,
                    "image": tuev_sued,
                    "alt": "TUEV Sued"
                },
                "3": {
                    "width": 35,
                    "height": 24,
                    "image": tuev_rheinland,
                    "alt": "TUEV Rheinland"
                },
                "4": {
                    "width": 35,
                    "height": 24,
                    "image": kues,
                    "alt": "KUES"
                },
                "5": {
                    "width": 35,
                    "height": 15,
                    "image": gtue,
                    "alt": "GTUE"
                },
                "6": {
                    "width": 35,
                    "height": 16,
                    "image": tuev_nord,
                    "alt": "TUEV Nord"
                }
            }
        };
        var currentProvider = providersizes[hintType];
        var currentData = currentProvider[providerId];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(classes),
            style: {
                height: currentData === null || currentData === void 0 ? void 0 : currentData.height,
                width: currentData === null || currentData === void 0 ? void 0 : currentData.width
            },
            children: (currentData === null || currentData === void 0 ? void 0 : currentData.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: currentData.image.src,
                alt: "".concat(currentData.alt),
                width: "".concat(currentData.width),
                height: "".concat(currentData.height)
            })
        });
    };
    return ServiceProviderHint;
}(react.PureComponent);


/***/ })

}]);